<template>
  <div>
    <div class="about-us">
      <h2 class="title primary_color">
        {{ $t('common.p24') }}
      </h2>
      <div class="line" />
      <h2 class="sub-title">
        {{ $t('about.p2') }}
      </h2>
      <p>{{ $t('about.p3') }}</p>
      <p>{{ $t('about.p4') }}</p>
      <p>{{ $t('about.p5') }}</p>
      <h2 class="sub-title margin-top">
        {{ $t('about.p6') }}
      </h2>
      <!-- <p>{{ $t('about.p7') }} {{ $t('about.p8') }}<a href="mailto:info@pppoker.net">info@pppoker.net</a></p>
    <p>{{ $t('about.p9') }} {{ $t('about.p8') }}<a href="mailto:branding@pppoker.net">branding@pppoker.net</a></p> -->
      <p>{{ $t('about.p7') }}</p>
      <i18n
        path="about.p8"
        tag="p"
      >
        <a
          class="primary_color"
          place="link"
          href="mailto:info@pppoker.net"
        >
          info@pppoker.net
        </a>
      </i18n>
      <p>{{ $t('about.p9') }}</p>
      <i18n
        path="about.p8"
        tag="p"
      >
        <a
          class="primary_color"
          place="link"
          href="mailto:branding@pppoker.net"
        >
          branding@pppoker.net
        </a>
      </i18n>
      <p>For Public Relationship Enquiry:</p>
      <i18n
        path="about.p8"
        tag="p"
      >
        <a
          class="primary_color"
          place="link"
          href="mailto:pr@pppoker.net"
        >
          pr@pppoker.net
        </a>
      </i18n>
    </div>
    <div class="divider_color" />
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  data () {
    return {
    }
  },
  created () {
    this.$store.commit('changeTab', 0)
  },
  methods: {
    toBrand () {
      this.$router.push({ name: 'brand' })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.about-us {
  // background-color: #2a2a2a;
  padding: 34px 26px 50px 26px;
  // color: #fff;

  // background-color: transparent;
  // border-width: 0px 0px 30px 0px;
  // border-style: solid;
  // border-image-slice: 0 0 30 0 fill;
  // border-image-repeat: stretched;
  // border-image-source: url('/official_mobile/static/img/bg/blog/3_blog_01/01.png');

  h2 {
   margin: 0px;
  }
  .title {
    font-size: 36px;
    // color: #129e53;
  }
  .line {
    margin: 28px 0px;
  }
  .sub-title {
    font-size: 32px;
    margin-bottom: 30px;
  }
  .margin-top {
    margin-top: 50px;
  }
  p {
    // font-size: 24px;
    // color: #9f9f9f;
    line-height: 46px;
    margin-bottom: 28px;
  }
  a {
    // color: #279754;
    // box-shadow: 0 2px;
    text-decoration: underline;
  }
}
</style>
